export default __webpack_public_path__ + "static/media/team-2.13ae2ce3.jpg";